import React, { useEffect, useState } from 'react';
import { Box, Container, CircularProgress } from '@mui/material';

const ServiceTerms: React.FC = () => {
  const [content, setContent] = useState<string | null>(null);
  useEffect(() => {
    fetch('/terms/service-terms.html')
      .then((res) => res.text())
      .then((raw) => {
        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(raw, 'text/html');
          setContent(doc.body.innerHTML);
        } catch {
          setContent(raw);
        }
      })
      .catch(() => setContent(''));
  }, []);
  if (content === null) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box
        component="div"
        sx={{
          // justify all policy text
          textAlign: 'justify',
          // Treat any heading tags as normal body text to prevent large font sizes
          '& h1, & h2, & h3, & h4, & h5, & h6': (theme) => ({ ...theme.typography.body1, mb: 2 }),
          '& p': (theme) => ({ ...theme.typography.body1, mb: 2 }),
          '& ol, & ul': (theme) => ({ ...theme.typography.body1, pl: 4, mb: 2 }),
          '& li': (theme) => ({ ...theme.typography.body1 }),
          '& a': (theme) => ({ color: theme.palette.primary.main, textDecoration: 'underline' }),
        }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </Container>
  );
};

export default ServiceTerms;